module.exports = __webpack_public_path__ + "img/temp1.5b050b52.jpg";